module.exports = __webpack_public_path__ + "static/media/leftarrow.2bd2f502.webp";